"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mui_1 = require("tss-react/mui");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const QButton_1 = __importDefault(require("components/QButton"));
const SetupStatusBar_1 = __importDefault(require("components/SetupStatusBar"));
const QCloseBox_1 = __importDefault(require("components/QCloseBox"));
const GettingStartedModule_1 = __importDefault(require("components/GettingStartedModule"));
const accounts_success_png_1 = __importDefault(require("assets/webFirst/accounts-success.png"));
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const GettingStartedModulePage = ({ skipText, showSuccess, config, onClose, onButtonClick, onCompleted }) => {
    const { classes } = useStyles();
    return (<Dialog_1.default open hideBackdrop={Boolean(showSuccess && config.successQCard)} disableEscapeKeyDown={config.noSkip} onClose={onClose} maxWidth="md" classes={{ paperWidthMd: classes.paperWidthMd }} BackdropProps={{ style: { opacity: 0.4 } }}>
      <QCloseBox_1.default onClose={onClose} id="set-up-your-quicken-close-button"/>

      <div style={{ height: '100%', padding: '10px 48px' }}>
        {!showSuccess &&
            <>
            <SetupStatusBar_1.default classes={{ root: classes.statusBar }} titleOnTop selected={config.page}/>
            <GettingStartedModule_1.default config={config}/>
          </>}
        {showSuccess &&
            <div style={{ textAlign: 'center' }}>
            <Typography_1.default className={classes.title} style={{ marginTop: 15 }}>
              Awesome!
            </Typography_1.default>
            <Typography_1.default className={classes.subTitle}>
              {config.success}
            </Typography_1.default>
            <img alt="Connection success" src={accounts_success_png_1.default} style={{ marginTop: 20 }}/>
            <Divider_1.default style={{ margin: 20, marginTop: 45, marginBottom: 45 }}/>
            <Typography_1.default className={classes.successTitle}>
              {config.successSub.title}
            </Typography_1.default>
            <Typography_1.default className={classes.successSubTitle}>
              {config.successSub.subTitle}
            </Typography_1.default>
          </div>}
      </div>

      <div className={classes.buttonArea}>
        {config.buttons.map((btn) => <div key={`SETUPBTN: ${btn.value}`}>
            <QButton_1.default variant={showSuccess ? null : 'contained'} classes={{ conButton: classes.setupButton, root: showSuccess ? classes.skipTextButton : classes.skipSecondaryTextButton }} onClick={(e) => onButtonClick(e, btn.value)} id={btn.id}>
              {btn.label}
            </QButton_1.default>
          </div>)}
        {onCompleted &&
            <div>
            <QButton_1.default variant={showSuccess ? 'contained' : null} classes={{ conButton: classes.setupButton, root: showSuccess ? classes.skipSecondaryTextButton : classes.skipTextButton }} onClick={onCompleted} id={`get-started-${skipText === null || skipText === void 0 ? void 0 : skipText.toLowerCase()}-button`}>
              {skipText}
            </QButton_1.default>
          </div>}
      </div>

      {!showSuccess && config.caption &&
            <Typography_1.default className={classes.bottomCaption} variant="caption">{config.caption}</Typography_1.default>}
    </Dialog_1.default>);
};
exports.default = GettingStartedModulePage;
